<template>
    <v-dialog @keydown.esc="hide" v-model="show" loading fullscreen hide-overlay transition="dialog-bottom-transition" style="overflow-x:hidden;">

        <v-btn dark style="position: absolute;top:14px;right:20px;z-index: 10;width:100px;"  text @click="deleteCard"> <v-icon>delete</v-icon>Radera</v-btn>
        <video id="video_flare2"  muted="" loop autoplay class="fullscreen-bg__video" style="">
            <source :src="require('../assets/white_flare.webm')" type="video/webm">

        </video>
        <v-card v-if="show" dark style="background:rgba(0,0,0,0.9)" >
            <v-toolbar   style="z-index: 1;position:relative;background: transparent;" dark >
                <v-btn icon dark @click="hide">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title v-if="this.$vuetify.breakpoint.mdAndUp">Action</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-list-item>
                        <v-list-item-avatar >
                            <v-img
                                    :src="'/api/images/cards/streamer_images/'+card_data.STID+'/avatar.png'"
                            ></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="headline">{{card_name}}</v-list-item-title>
                            <v-list-item-subtitle>med {{this.$store.state.STREAMER.USER_NAME}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>

                        <v-btn style=""  small class="mx-auto" :class="rank_color">
                            {{rank_text}}
                        </v-btn>
                    </v-list-item>


                </v-toolbar-items>

                <v-spacer></v-spacer>


                <v-progress-linear
                        v-if="loading"
                        style="position:absolute;bottom:0;left:0;"
                        color="teal"
                        height="10"
                        value="100"
                        striped
                        indeterminate
                ></v-progress-linear>


            </v-toolbar>









            <v-card-text>

            </v-card-text>
            <v-navigation-drawer
                    absolute
                    permanent
                    class="transparent"
                    right
                    dark
                    clipped
                    floating
                    width="400"
                    v-if="card_data!==null && this.$vuetify.breakpoint.mdAndUp"
            >
                <v-container fill-height fluid>
                    <v-row align="center"
                           justify="center">
                        <v-col>

                            <v-card
                                    color="transparent"
                                    flat


                            ><v-card-text style="width:275px;padding:0;padding-top:10px;" class="mx-auto">
                                <v-text-field
                                        style="font-family:Merienda;resize:none !important;color:white;padding:0;" cols="1" data-limit-rows="true"
                                        outlined
                                        name="input-7-4"
                                        label="Kortnamn"
                                        rows="1"
                                        no-resize
                                        width="265"
                                        :counter=25
                                        v-on:input="updateName"
                                        :value=card_name

                                        class="cardInput"
                                ></v-text-field>



                            </v-card-text>


                                <v-card-text style="width:275px;padding:0;margin-top:25px;" class="mx-auto">
                                    <v-textarea
                                            style="font-family:Merienda;resize:none !important;color:white;padding:0;" cols="1" data-limit-rows="true"
                                            outlined
                                            name="input-7-4"
                                            label="Korttext"
                                            rows="4"
                                            no-resize
                                            width="265"
                                            :counter=110
                                            v-on:input="updateText"
                                            class="cardInput"
                                            :value=card_text
                                    ></v-textarea>


                                    <div style="border-collapse: collapse;  border-style: solid; border-width: 1px;border-radius:4px;" class="makeMeGray">
                                        <v-menu
                                                v-model="menu"
                                                :close-on-content-click="false"
                                                :nudge-width="200"
                                                top
                                                offset-y
                                                transition="fade-transition"
                                                elevation="0"
                                        >
                                            <template v-slot:activator="{ on }">


                                                <v-btn v-if="card_data.VIDEO.url!=='' && card_data.VIDEO.url!==null" class="mx-auto coverme" x-large :style="{'backgroundImage':cardVideoImage}" v-on="on" style="width:100%;;background-size:cover !important;background:center;height:100px;">
                                                </v-btn>
                                                <v-btn v-else class="mx-auto" x-large  v-on="on" style="width:100%;height:100%;;background-size:cover;background:center;">
                                                    <v-icon left>mdi-plus</v-icon>Media
                                                </v-btn>

                                            </template>
                                            <VideoSelector v-on:saveviewer="saveviewer" v-on:save="save_card" v-on:updateVideo="updateVideo"   :video_data="card_data.VIDEO">

                                            </VideoSelector>
                                        </v-menu>
                                    </div>
                                    <div style="padding-top:10px;">Media-effekter visas live på stream när tillhörande kort används</div>
                                </v-card-text>



                            </v-card>


                            <v-row>
                                <v-col><v-btn @click="flexTest" text><v-icon>send</v-icon> Testa</v-btn></v-col>
                                <v-col>

                                </v-col>
                                <v-col>

                                    <v-btn dark @click="save_card"  class="mx-auto" :class="rank_color">
                                        <v-icon left>save</v-icon> Spara
                                    </v-btn>
                                </v-col>
                            </v-row>

                        </v-col>
                    </v-row>
                </v-container>





            </v-navigation-drawer>
        </v-card>

        <div id="renderContainerAction" style="z-index:0;top:0;position:absolute;width:100%;height:100%;">
            <canvas id="renderCanvasAction"></canvas>
        </div>
        <canvas style="display:none;visibility:hidden;" id="normalMapper" height="890" width="640"></canvas>



        <v-row style="position:absolute;bottom:0;" v-if="card_data!==null && this.$vuetify.breakpoint.smAndDown">
            <v-col cols="2"></v-col>
            <v-col cols="8">

            </v-col >
            <v-col cols="2"></v-col>

        </v-row>

    </v-dialog>
</template>

<script>
    import * as Three from 'three'
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
    import {ActionCard3D} from "../helpers/ActionCard3D"
    import VideoSelector from "../components/VideoSelector"






    export default {
        name: "ActioncardHolderEdit",
        components: {VideoSelector},
        props:{
            "card_data":Object,
            "index":Number,
            show:Boolean
        },
        data(){
            return{
                loading:true,
                camera: null,
                scene: null,
                renderer: null,
                mesh: null,
                controls:null,
                card:null,
                camToSave:{},
                model:1,
                collection:"",
                byRank:-1,
                byModel:-1,
                mobileShow:false,
                renderCanvas:null,
                renderContainer:null,
                newName:null,
                showVideoModal:false,
                menu:null,
                newText:null,
                newVideo:null,
                updateCardTimer:null,
                saveCardTimer:null



            }
        },
        methods: {

            saveviewer:function(){
                this.card_video.video_id="FFA";
                this.save_card();
            },

            hide:function(){
                this.menu=false;
                this.$emit("hide")
            },

            updateText(payload){
                this.current_card.updateText(payload);
                this.newText=payload;
                this.updateCardData();
            },
            setText(payload){
                this.current_card.updateText(payload);
                this.newText=payload;

            },
            updateName(payload){
                this.newName=payload;
                this.updateCardData();
            },
            updateVideo(payload){
                console.log(payload);
                this.newVideo=payload;
                this.updateCardData();
            },
            updateCardData(){
                clearTimeout(this.updateCardTimer);
                let self=this;
                let updateData={
                    DELETED:0,
                    ACMID:this.card_data.ACMID,
                    TEXT:this.card_text,
                    NAME:this.card_name,
                    VIDEO:this.card_video,
                    RANK:this.card_data.RANK,
                    INDEX:this.index


                };
                setTimeout(function(){
                    self.$emit("update",updateData)
                },50)
                clearTimeout(this.saveCardTimer);

            },
            init: function() {
                this.renderCanvas= document.getElementById('renderCanvasAction');
                this.renderContainer= document.getElementById('renderContainerAction');

                this.camera = new Three.PerspectiveCamera(70, this.renderContainer.clientWidth/this.renderContainer.clientHeight, 0.1, 1000);
                this.camera.position.z = 10;


                this.scene = new Three.Scene();

                let light1 = new Three.PointLight( "white", 0.75 );
                let light2 = new Three.PointLight( "white", 0.75 );
                let light3 = new Three.AmbientLight( "white", 0.2 );
                light1.position.set( 0, 5, 50 );
                light2.position.set(0, 5, -50 );

                this.scene.add(light1);
                this.scene.add(light2);
                this.scene.add(light3);

                this.renderer = new Three.WebGLRenderer({canvas:this.renderCanvas,antialias:true,alpha:true,preserveDrawingBuffer: true });
                this.renderer.sortObjects = false;

                this.renderer.setSize(this.renderContainer.clientWidth, this.renderContainer.clientHeight);
                this.controls = new OrbitControls(this.camera, this.renderer.domElement);
                this.controls.enableDamping=true;
                this.controls.maxDistance=10;
                this.controls.minDistance=5;
                this.controls.enablePan=false;
                //this.controls.autoRotate=true;
                this.controls.dampingFactor=0.05;
                this.controls.autoRotateSpeed=5;

                this.controls.rotateSpeed=1;

                this.camera.position.z=10;
                this.current_card=null;
                this.camera.position.z=10;
                this.camToSave.position = this.camera.position.clone();
                this.camToSave.rotation = this.camera.rotation.clone();
                this.camToSave.controlCenter = this.controls.target.clone();
                //container.appendChild(this.renderer.domElement);
                this.updateCard();
                this.loading=false;


            },

            onResize:function(){
                //let container=document.getElementById('container0');
                if(this.show){
                    this.camera.aspect = document.getElementById("renderContainerAction").clientWidth / document.getElementById("renderContainerAction").clientHeight;
                    this.camera.updateProjectionMatrix();

                    document.getElementById("renderCanvasAction").width=document.getElementById("renderContainerAction").clientWidth;
                    document.getElementById("renderCanvasAction").height=document.getElementById("renderContainerAction").clientHeight;


                    this.renderer.setSize( document.getElementById("renderContainerAction").clientWidth , document.getElementById("renderContainerAction").clientHeight );
                }

            },
            animate: function() {
                requestAnimationFrame(this.animate);
                this.controls.update();
                this.renderer.render(this.scene, this.camera);
            },
            updateCard:function(){

                    this.newName=null;
                    this.newText=null;
                    this.newVideo=null;
                    this.current_card=new ActionCard3D(this.card_data);
                    let removeMe = this.scene.getObjectByName("card");
                    if(removeMe!==null){
                        this.scene.remove(removeMe);
                    }
                    let ac=this.current_card.render();
                    ac.name="card";
                    this.restoreCamera(this.camToSave.position, this.camToSave.rotation, this.camToSave.controlCenter);
                    this.scene.add(ac);
                    this.setText(this.card_data.TEXT)


            },
            save_card(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/save_card?';
                let videoInfo={opacity:this.card_video.opacity,
                    volume:this.card_video.volume,
                    video_id:this.card_video.video_id,
                    start:this.card_video.start,
                    end:this.card_video.end};
                console.log(videoInfo);
                let params="RANK="+this.card_data.RANK+"&TEXT="+this.card_text+"&NAME="+this.card_name+"&ID="+this.card_data.ACMID+"&VIDEO="+JSON.stringify(videoInfo);
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        console.log("error");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        console.log("saved");
                        self.$emit("refresh");

                    }

                };
                http.send(params);
            },
            deleteCard:function(){
                let http = new XMLHttpRequest();

                http.withCredentials = true;
                let url = '/api/delete_card?';
                let params="ID="+this.card_data.ACMID;
                http.open('POST', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        console.log("error");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$emit("refresh");
                        self.hide();

                    }


                };
                http.send(params);
            },
            get_card_uq:function(){
                this.collection="";
                this.byRank=-1;
                this.byModel=-1;
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/get_card_uq?CID='+this.card_data.CID;

                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {
                        console.log("err")

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        if(http.responseText==="no data"){
                            return {"COLLECTION_NAME":"Okänd","BYMODEL":0,"BYRANK":0}
                        }
                        else{
                            let data = JSON.parse(http.response);
                            self.byModel=data[0].BYMODEL;
                            self.byRank=data[0].BYRANK;
                            self.collection=data[0].COLLECTION_NAME



                        }

                    }


                };
                http.send();
            },
            restoreCamera(position, rotation, controlCenter){
                this.camera.position.set(position.x, position.y, position.z);
                this.camera.rotation.set(rotation.x, rotation.y, rotation.z);
                this.controls.target.set(controlCenter.x, controlCenter.y, controlCenter.z);
                this.controls.update();
            },
            flexTest:function testCard(){
                let http = new XMLHttpRequest();

                http.withCredentials = true;
                let url = '/api/test_card?';
                let params="ID="+this.card_data.ACMID;
                http.open('POST', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");


                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$store.commit("update_snackbar","Testkort-skickat!");

                    }
                    else if(http.readyState === 4 && http.status !== 200){
                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                };
                http.send(params);

            }

        },
        mounted() {
            if(this.card_data!==null){
                let self=this;

                setTimeout(function(){
                    self.init();
                    self.animate();
                    window.addEventListener('resize', self.onResize)
                },500);
            }
        },
        watch:{
            card_data:function(){
                if(this.card_data!==null && this.show){
                    if(this.scene===null){
                        let self=this;

                        setTimeout(function(){
                            self.init();
                            self.animate();
                            window.addEventListener('resize', self.onResize)
                        },500);


                    }
                    else{
                        let self=this;
                        setTimeout(function(){
                            self.onResize();

                        },500);

                        this.updateCard();

                    }
                }

            }
        },
        computed:{
            card_video:function(){
                if(this.newVideo===null){
                    return this.card_data.VIDEO;
                }
                else{
                    return this.newVideo;
                }
            },
            cardVideoImage:function(){
               if(this.newVideo!==null){
                   return `url('https://img.youtube.com/vi/${this.newVideo.video_id}/0.jpg')`
               }
               else if(this.card_data.VIDEO.video_id==="FFA"){
                   return `url('/api/images/cards/youdecidevideo.png')`

               }
               else if(this.card_data.VIDEO.video_id!==null){
                    return `url('https://img.youtube.com/vi/${this.card_data.VIDEO.video_id}/0.jpg')`
                }
               else{
                   return `url('https://img.youtube.com/vi/123/0.jpg')`
               }





            },

            card_name:function(){

                if(this.newName!==null){
                    return this.newName
                }

                else{
                    return this.card_data.NAME;

                }
            },
            card_text:function(){
                if(this.newText===""){
                    return ""
                }
                else if(this.newText!==null){
                    return this.newText
                }

                else{
                    return this.card_data.TEXT;

                }
            },

            rank_color:function(){
                if(this.card_data.RANK===0){
                    return "green"
                }
                else if(this.card_data.RANK===1){
                    return "blue"
                }
                else if(this.card_data.RANK===2){
                    return "purple"
                }
                else if(this.card_data.RANK===3){
                    return "orange"
                }
                else{
                    return "black"
                }
            },
            rank_text:function(){
                if(this.card_data.RANK===0){
                    return "Vanlig"
                }
                else if(this.card_data.RANK===1){
                    return "Ovanlig"
                }
                else if(this.card_data.RANK===2){
                    return "Epic"
                }
                else if(this.card_data.RANK===3){
                    return "Legendary"
                }
                else{
                    return "Okänd"
                }
            },
            float:function(){
                return (Math.sqrt((this.card_data.FLOAT_X*this.card_data.FLOAT_X)+(this.card_data.FLOAT_Y*this.card_data.FLOAT_Y))/Math.sqrt(2));
            }
        }
    }
</script>

<style>

    .cardInput > * textarea{
        padding:0 !important;
    }

    .makeMeGray{
         border:1px solid gray;

     }
    .makeMeGray > span{
        color:gray;

    }
    .makeMeGray:hover >span{
        color:white;
    }

    .makeMeGray:hover{
        border:1px solid white;
    }

    .coverme{
        background-size: cover !important;
    }

</style>
